module.exports = __webpack_public_path__ + "static/media/Dysrhythmia_Question5.41d7e073.jpg";